const normalize = (value) => String(value || "").trim().toLowerCase()

const mountContactLibrary = () => {
  document.querySelectorAll("[data-contact-library]").forEach((container) => {
    if (container.dataset.contactLibraryMounted === "true") return
    container.dataset.contactLibraryMounted = "true"

    const searchInput = container.querySelector("[data-contact-search-input]")
    const emptyState = container.querySelector("[data-contact-search-empty]")
    const cards = Array.from(container.querySelectorAll("[data-contact-card]"))
    const drawerKicker = container.querySelector("[data-contact-drawer-kicker]")
    const drawerTitle = container.querySelector("[data-contact-drawer-title]")
    const drawerSubtitle = container.querySelector("[data-contact-drawer-subtitle]")
    const drawerSections = Array.from(container.querySelectorAll("[data-contact-drawer-section]"))

    const setDrawerSection = (target, contactId = null) => {
      const nextSection = drawerSections.find((section) => {
        if (section.dataset.contactDrawerSection !== target) return false
        if (target !== "edit") return true

        return section.dataset.contactId === contactId
      })

      drawerSections.forEach((section) => {
        section.hidden = section !== nextSection
      })

      if (!nextSection) return

      if (drawerKicker) drawerKicker.textContent = nextSection.dataset.contactDrawerKickerValue || "Contact"
      if (drawerTitle) drawerTitle.textContent = nextSection.dataset.contactDrawerTitleValue || "Contact"
      if (drawerSubtitle) drawerSubtitle.textContent = nextSection.dataset.contactDrawerSubtitleValue || ""
    }

    const filter = () => {
      if (!searchInput) return

      const query = normalize(searchInput.value)
      let anyVisible = false

      cards.forEach((card) => {
        const matches = query.length === 0 || normalize(card.dataset.contactSearchText).includes(query)
        card.hidden = !matches
        if (matches) anyVisible = true
      })

      if (emptyState) emptyState.hidden = anyVisible
    }

    container.addEventListener("click", (event) => {
      const trigger = event.target.closest("[data-contact-drawer-target]")
      if (!trigger) return

      setDrawerSection(trigger.dataset.contactDrawerTarget, trigger.dataset.contactId || null)
    })

    searchInput?.addEventListener("input", filter)

    setDrawerSection("create")
    filter()
  })
}

export { mountContactLibrary }
